import { useEffect } from 'react';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import { setSelectedMeasures } from '../../../../store/process-analysis-store/process-analysis-store.actions';
import {
  useComparisonMode,
  useFilterWasTouched,
} from '../../../../store/process-analysis-store/process-analysis-store.hooks';
import { KEY_MEASURES } from '../../process-analysis.constants';
import { ComparisonMode } from '../../process-analysis.type';

/**
 * Hook to handle auto-selection of measures for measure comparison when filters haven't been touched by the user
 *
 * @returns {void}
 */
const useAutoSelectFilters = (): void => {
  const availableMeasures = useProcessAnalysisStore((state) => state.availableMeasures);
  const comparisonMode = useComparisonMode();
  const measuresWasTouched = useFilterWasTouched('selectedMeasures');

  useEffect(() => {
    if (availableMeasures.length === 0) return;

    const isSingleMode = comparisonMode === ComparisonMode.Single;
    // In single mode, only auto-select if filters haven't been touched
    // In multiple mode, always auto-select (no entity filters)
    const shouldAutoSelectKeyMeasures = !isSingleMode || !measuresWasTouched;

    if (shouldAutoSelectKeyMeasures) {
      setSelectedMeasures(KEY_MEASURES);
    }
  }, [availableMeasures, comparisonMode, measuresWasTouched]);
};

export { useAutoSelectFilters };
